import { sortByTypeType } from '../../utils/constants';
import { HiOutlineChevronDown, HiOutlineChevronUp } from 'react-icons/hi';

type SortIconProps = {
  sortByType: string
}

const SortIcon = (props: SortIconProps) => {
  const { sortByType } = props;
  return sortByType === sortByTypeType.DESC ? <HiOutlineChevronDown size={16} /> : <HiOutlineChevronUp size={16} />;
}

export default SortIcon;
